module.exports = __webpack_public_path__ + "img/page7img4.c6aa5ecc.png";